import {
  DELETE_DRIVER_REQUEST,
  DELETE_DRIVER_ERROR,
  DELETE_DRIVER_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_DRIVER_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_DRIVER_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_DRIVER_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "driver";
  context.entityLocation = RESOURCES.Drivers;

  return context.execute(context)(entity)(state, action);
};